import { type Quantity } from '@luminovo/api-contracts';
import { QuantityHelper } from '@luminovo/commons';
import { formatQuantity } from '@luminovo/data-stack';
import { Tag } from '@luminovo/design-system';
import type { JSX } from 'react';

export const UnitOfMeasurementTag = ({ unitOfMeasurement }: { unitOfMeasurement: Quantity }): JSX.Element => {
    const value = QuantityHelper.from(unitOfMeasurement).parseValue();
    return (
        <Tag
            attention={'low'}
            color={value === 1 ? 'neutral' : 'yellow'}
            label={formatQuantity(unitOfMeasurement, { showPiecesUnit: true })}
        />
    );
};
